import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ToastController, AlertController } from '@ionic/angular';
import { KilnService } from 'src/app/services/kiln.service';
import { RequestsService } from '../services/requests.service';

@Component({
  selector: 'app-stop-firing-button',
  templateUrl: './stop-firing-button.component.html',
  styleUrls: ['./stop-firing-button.component.scss']
})
export class StopFiringButtonComponent implements OnChanges {
  @Input() kiln: any;
  @Input() gotData: boolean = false;
  @Input() notConnected: boolean = false;
  @Output() firingStopped = new EventEmitter<void>();
  @Output() stopError = new EventEmitter<string>();

  public stoppingFiring = false;
  public isPairedToMe: boolean = false;

  constructor(
    private toastCtrl: ToastController,
    private alertController: AlertController,
    private kilnService: KilnService,
    private requestsService: RequestsService
  ) {}

  async stopFiring() {
    // Show confirmation dialog first
    const alert = await this.alertController.create({
      header: 'Stop Firing',
      message: 'Are you sure you want to stop firing? This action cannot be undone through the app.',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary'
        },
        {
          text: 'Stop Firing',
          cssClass: 'danger',
          handler: async () => {
            this.stoppingFiring = true;
            
            try {
              if(this.isPairedToMe) {
                await this.kilnService.stopFiring(this.kiln.external_id);
                await this.requestsService.populateRemoteRequests(this.kiln.external_id);
                this.firingStopped.emit();
              } else {
                this.stopError.emit('You are not paired to this kiln.');
              }
            } catch (error) {
              this.stopError.emit('Failed to stop firing. Please try again.');
            } finally {
              this.stoppingFiring = false;
            }
          }
        }
      ]
    });

    await alert.present();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['kiln'] && this.kiln) {
      this.checkPairingStatus();
    }

    this.requestsService.remoteRequestsByExternalId.subscribe((remoteRequests) => {
      if(remoteRequests && remoteRequests[this.kiln.external_id] && remoteRequests[this.kiln.external_id].length > 0) {        
        this.stoppingFiring = remoteRequests[this.kiln.external_id].some((request) => {
          return request.key === 'stop' && request.status === 'pending';
        });
      }
    });
  }

  checkPairingStatus() {
    if (this.kiln && (this.kiln.serial_number)) {
      const kilnId = this.kiln.serial_number;
      this.kilnService.checkPairing(kilnId)
        .then((response: any) => {
          this.isPairedToMe = response?.isPairedToMe === true;
        })
        .catch((error) => {
          console.error('Error checking pairing status:', error);
          this.isPairedToMe = false;
        });
    }
  }

  shouldShowButton(): boolean {
    return this.kiln && 
           this.gotData && 
           !this.notConnected && 
           this.kiln.status && 
           this.kiln.status.mode === 'Firing';
  }
} 